class ScriptManager {
    constructor() {
        this.cleanupFunctions = [];
    }

    async loadGSAP() {
        const scripts = [
            'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js',
            'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js',
        ];

        for (const src of scripts) {
            await new Promise((resolve, reject) => {
                if (document.querySelector(`script[src="${src}"]`)) {
                    resolve();
                    return;
                }
                const script = document.createElement('script');
                script.src = src;
                script.onload = resolve;
                script.onerror = () => reject(new Error(`Failed to load: ${src}`));
                document.head.appendChild(script);
            });
        }

        if (window.gsap && window.ScrollTrigger) {
            gsap.registerPlugin(ScrollTrigger);
        }
    }

    async init() {
        await this.loadGSAP();
        this.initializeAnimations();
        window.scrollTo(0, 0);
    }

    initializeAnimations() {
        const cleanups = [
            preloaderAnimation(),
            parallaxSectionAnimation(),
            headerScrollAnimation(),
            parallaxEffect()
        ];

        cleanups.forEach(fn => {
            if (typeof fn === 'function') {
                window.animationManager.register(fn);
                this.cleanupFunctions.push(fn);
            }
        });
    }

    cleanup() {
        this.cleanupFunctions.forEach(fn => fn());
        this.cleanupFunctions = [];
        window.animationManager.destroy();
    }
}


function preloaderAnimation() {


    let loadTl = gsap.timeline({
        onComplete: () => {
   
            
        }
    });

    
    loadTl.to("main", {
        opacity: 1,
        autoAlpha: 1,
        duration: 0.5,
        ease: "power2.inOut",
    });



    return () => {
        if (loadTl.Flip) {
            loadTl.Flip.kill();
        }
        loadTl.kill();
    };
}

function headerScrollAnimation() {
    const header = document.querySelector('header');
    if (!header) return;

    const scrollTrigger = ScrollTrigger.create({
        start: '10px top',
        onEnter: () => {
            gsap.to(".header > *", {
                color: 'var(--header-scroll)',
                duration: 0.3,
                ease: 'power2.out'
            });

            gsap.to(".header__heading-logo", {
                filter: 'var(--header-logo-scroll)',
                duration: 0.3,
                ease: 'power2.out'
            });

            gsap.to(header, {
                backgroundColor: 'var(--header-bg-scroll)',
                duration: 0.5,
                ease: 'power2.out'
            });
        },
        onLeaveBack: () => {
            gsap.to(".header > *", {
                color: 'var(--header-color)',
                duration: 0.3,
                ease: 'power2.out'
            });

            gsap.to(".header__heading-logo", {
                filter: 'var(--header-logo)',
                duration: 0.3,
                ease: 'power2.out'
            });

            gsap.to(header, {
                backgroundColor: 'var(--header-bg)',
                duration: 0.5,
                ease: 'power2.out'
            });
        }
    });

    return () => scrollTrigger.kill();
}

document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('load', () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                window.scriptManager = new ScriptManager();
                window.scriptManager.init();
            });
        });
    });
});

window.addEventListener('beforeunload', () => {
    if (window.scriptManager) {
        window.scriptManager.cleanup();
    }
});